import { AssociationType, AssociationRecord } from "../association";

import { EventRecord } from "./EventRecord";

export function groupAssociationsByType(
  event: EventRecord,
): Record<AssociationType, AssociationRecord[]> {
  const associationsByType: Record<AssociationType, AssociationRecord[]> = {
    [AssociationType.Dataset]: [],
    [AssociationType.Device]: [],
    [AssociationType.DeviceType]: [],
    [AssociationType.File]: [],
    [AssociationType.MessagePath]: [],
    [AssociationType.Org]: [],
    [AssociationType.Topic]: [],
  };

  event.associations.forEach((association) => {
    associationsByType[association.association_type].push(association);
  });

  return associationsByType;
}
